module.exports = __webpack_public_path__ + "img/制御工学7_3_5.be2449dd.png";